var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 79,
    viewBox: "0 0 114 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2138 77C64.7908 77 77.3401 76.9053 91.7362 68.5707C106.132 60.236 110.821 49.8651 112.289 44.5139C112.424 44.0319 112.461 43.5276 112.398 43.0309C112.334 42.5343 112.172 42.0554 111.92 41.6226C111.669 41.1899 111.333 40.812 110.932 40.5115C110.532 40.211 110.075 39.9938 109.589 39.873C106.132 38.9733 100.071 38.1682 92.3045 40.0151M57.2138 77C49.6369 77 37.0876 76.8579 22.6914 68.5707C8.29527 60.2834 3.60704 49.8651 2.13901 44.5139C2.0038 44.0319 1.96673 43.5276 2.02998 43.0309C2.09323 42.5343 2.25551 42.0554 2.50723 41.6226C2.75894 41.1899 3.09496 40.812 3.49537 40.5115C3.89578 40.211 4.35244 39.9938 4.83829 39.873C8.29527 38.9733 14.3568 38.1682 22.1232 39.9677M57.2138 77C57.2138 77 76.1562 66.6764 76.1562 39.1153C76.1562 17.5211 64.5066 6.53453 59.4869 2.74606C58.8281 2.26141 58.0317 2 57.2138 2C56.396 2 55.5995 2.26141 54.9408 2.74606C49.921 6.53453 38.2715 17.5211 38.2715 39.1153C38.2715 66.6764 57.2138 77 57.2138 77ZM57.2138 77C62.8965 75.7687 78.1925 67.15 87.3795 51.2384C96.5665 35.3269 94.2934 22.6829 92.4939 17.1422C92.2187 16.2512 91.6166 15.4972 90.8085 15.0316C90.0004 14.5661 89.0461 14.4235 88.1372 14.6324C82.6999 15.8501 77.6135 18.2961 73.2675 21.7831M57.2138 77C51.5311 75.7687 36.2352 67.1026 27.0482 51.2384C17.8611 35.3742 20.1342 22.6829 21.9337 17.1422C22.209 16.2512 22.8111 15.4972 23.6192 15.0316C24.4273 14.5661 25.3816 14.4235 26.2905 14.6324C31.7278 15.8501 36.8142 18.2961 41.1602 21.7831",
    stroke: "url(#paint0_linear_554_1455)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_554_1455",
    x1: 57.2138,
    y1: 2,
    x2: 57.2138,
    y2: 77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EAFF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#4063B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704BA5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityIcon);
export default __webpack_public_path__ + "static/media/integrity_icon.b9f07d628a264b79d1672b7db7854197.svg";
export { ForwardRef as ReactComponent };